import { render, staticRenderFns } from "./AddAgendaTopicDetails.vue?vue&type=template&id=41374e2a&scoped=true&"
import script from "./AddAgendaTopicDetails.vue?vue&type=script&lang=js&"
export * from "./AddAgendaTopicDetails.vue?vue&type=script&lang=js&"
import style0 from "./AddAgendaTopicDetails.vue?vue&type=style&index=0&id=41374e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41374e2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSelect,VTextField,VTooltip})
